module.exports = __webpack_public_path__ + "resources/img/ico-company-history@2x.ba0e5ddc.png";